import { Component, OnInit } from "@angular/core";
import { ApikeysService } from "../service/apikeys.service";
import { Shop, ApiKeysDto } from "cilor-db-api-shared";

@Component({
  selector: "app-apikeys-page",
  templateUrl: "./apikeys-page.component.html",
  styleUrls: ["./apikeys-page.component.scss"]
})
export class ApikeysPageComponent implements OnInit {

  constructor(
    public apikeysService: ApikeysService,
  ) { }

  ngOnInit(): void {
    this.apikeysService.loadApiKeys();
  }

  public shops(): Shop[] {
    return Object.values(Shop);
  }

  public shopDisplay(shop: Shop): string {
    switch (shop) {
      case Shop.minora: return "Minora";
      case Shop.cilorB2B: return "Cilor B2B";
      case Shop.cilorB2C: return "Cilor B2C";
      case Shop.tw: return "Trauringwunder";
      case Shop.schmuckwunder: return "Schmuckwunder";
    }
  }

  public getApiUrl(shop: Shop, data: ApiKeysDto): string {
    const url = new URL(location.href);
    return `${url.protocol}//${url.host}/api/products/wordpress?key=${data.keys[shop]}`;
  }
}
